"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGetMapUrl = exports.createGetLegendGraphicUrl = exports.parseLayer = exports.getAllLayerDays = exports.parseLayerDays = exports.getLayerDates = exports.parseLayerDates = exports.getLayerNames = exports.getLayerIds = exports.findLayer = exports.findTitle = exports.findLayers = void 0;
var xml_utils_1 = require("xml-utils");
var lodash_1 = require("lodash");
var utils_1 = require("../../utils");
function findLayers(xml) {
    return (0, xml_utils_1.findTagsByPath)(xml, ["Layer", "Layer"]).map(function (tag) { return tag.outer; });
}
exports.findLayers = findLayers;
function findTitle(xml) {
    return (0, utils_1.findTagText)(xml, "Title");
}
exports.findTitle = findTitle;
function findLayer(xml, layerName, options) {
    var result = findLayers(xml).find(function (layer) {
        var name = (0, utils_1.findName)(layer);
        return name && (name === layerName || (0, utils_1.parseName)(name).short === layerName);
    });
    if (result === undefined && (options === null || options === void 0 ? void 0 : options.errorStrategy) === "throw") {
        throw Error("failed to find layer with name \"".concat(layerName, "\""));
    }
    return result;
}
exports.findLayer = findLayer;
function getLayerIds(xml) {
    return findLayers(xml)
        .map(function (layer) { return (0, utils_1.findName)(layer) || ""; })
        .filter(function (id) { return id !== ""; });
}
exports.getLayerIds = getLayerIds;
function getLayerNames(xml, 
// sometimes layer titles will have an extra space in the front or end unsuitable for display
_a) {
    var 
    // sometimes layer titles will have an extra space in the front or end unsuitable for display
    _b = _a === void 0 ? { clean: false } : _a, _c = _b.clean, clean = _c === void 0 ? false : _c;
    var layers = findLayers(xml);
    var titles = layers.map(function (layer) { return findTitle(layer) || ""; });
    var filteredTitles = titles.filter(function (title) { return title !== ""; });
    return clean ? filteredTitles.map(function (title) { return title.trim(); }) : filteredTitles;
}
exports.getLayerNames = getLayerNames;
function parseLayerDates(xml) {
    var _a, _b;
    if (!xml) {
        throw Error("called parseLayerDates with nothing");
    }
    var dimensions = (0, xml_utils_1.findTagsByName)(xml, "Dimension");
    var timeDimension = dimensions.find(function (dimension) {
        return (0, xml_utils_1.getAttribute)(dimension.outer, "name") === "time";
    });
    // we have to trim because sometimes WMS adds spaces or new line
    if ((_a = timeDimension === null || timeDimension === void 0 ? void 0 : timeDimension.inner) === null || _a === void 0 ? void 0 : _a.trim()) {
        return timeDimension.inner
            .trim()
            .split(",")
            .map(function (datetime) { return datetime.trim(); });
    }
    // we weren't able to find any times using the <Dimension name="time">
    // so let's try <Extent name="time">
    var extents = (0, xml_utils_1.findTagsByName)(xml, "Extent");
    var timeExtent = extents.find(function (extent) {
        return (0, xml_utils_1.getAttribute)(extent.outer, "name") === "time";
    });
    // we have to trim because sometimes WMS adds spaces or new line
    if ((_b = timeExtent === null || timeExtent === void 0 ? void 0 : timeExtent.inner) === null || _b === void 0 ? void 0 : _b.trim()) {
        return timeExtent.inner
            .trim()
            .split(",")
            .map(function (datetime) { return datetime.trim(); });
    }
    return [];
}
exports.parseLayerDates = parseLayerDates;
function getLayerDates(xml, layerName) {
    var layer = findLayer(xml, layerName);
    if (!layer) {
        throw Error("can't find layer");
    }
    return parseLayerDates(layer);
}
exports.getLayerDates = getLayerDates;
function parseLayerDays(xml) {
    if (!xml) {
        throw Error("can't call parseLayerDays with nothing");
    }
    var dateStrings = parseLayerDates(xml);
    // round to noon to avoid errors due to daylight saving
    var days = dateStrings.map(utils_1.setNoon);
    var uniqueDays = (0, lodash_1.uniq)(days);
    return uniqueDays.map(function (date) { return new Date(date).getTime(); });
}
exports.parseLayerDays = parseLayerDays;
function getAllLayerDays(xml) {
    var layers = findLayers(xml);
    var allDays = {};
    layers.forEach(function (layer) {
        var layerId = (0, utils_1.findName)(layer);
        if (layerId) {
            var oldLayerDays = allDays[layerId] || [];
            var layerDays = parseLayerDays(layer);
            allDays[layerId] = (0, lodash_1.union)(layerDays, oldLayerDays);
        }
        return allDays;
    });
    return allDays;
}
exports.getAllLayerDays = getAllLayerDays;
// parses an xml representation of a layer
// converting into into an object
function parseLayer(xml) {
    if (!xml) {
        throw new Error("can't call parseLayer with nothing!");
    }
    var name = (0, utils_1.findName)(xml);
    if (!name) {
        return undefined;
    }
    var _a = (0, utils_1.parseName)(name), short = _a.short, namespace = _a.namespace;
    return {
        name: short,
        namespace: namespace,
        abstract: (0, utils_1.findAndParseAbstract)(xml),
        keywords: (0, utils_1.findTagArray)(xml, "Keyword"),
        srs: (function () {
            // sometimes called CRS or SRS depending on the WMS version
            return __spreadArray(__spreadArray([], __read((0, utils_1.findTagArray)(xml, "CRS")), false), __read((0, utils_1.findTagArray)(xml, "SRS")), false);
        })(),
        bbox: (function () {
            var ExGeographicBoundingBox = (0, xml_utils_1.findTagByName)(xml, "EX_GeographicBoundingBox");
            if (ExGeographicBoundingBox) {
                var inner = ExGeographicBoundingBox.inner;
                if (inner) {
                    return [
                        Number((0, utils_1.findTagText)(inner, "westBoundLongitude")),
                        Number((0, utils_1.findTagText)(inner, "southBoundLatitude")),
                        Number((0, utils_1.findTagText)(inner, "eastBoundLongitude")),
                        Number((0, utils_1.findTagText)(inner, "northBoundLatitude")),
                    ];
                }
            }
            return undefined;
        })(),
        attribution: (function () {
            var tag = (0, xml_utils_1.findTagByPath)(xml, ["Attribution", "Title"]);
            if (!(tag === null || tag === void 0 ? void 0 : tag.inner)) {
                return undefined;
            }
            return { title: tag.inner };
        })(),
        dates: parseLayerDates(xml),
        styles: [], // to-do
    };
}
exports.parseLayer = parseLayer;
function createGetLegendGraphicUrl(_a) {
    var base = _a.base, bgColor = _a.bgColor, columnHeight = _a.columnHeight, countMatched = _a.countMatched, dpi = _a.dpi, exceptions = _a.exceptions, featureType = _a.featureType, _b = _a.fontAntiAliasing, fontAntiAliasing = _b === void 0 ? true : _b, _c = _a.fontColor, fontColor = _c === void 0 ? "0x2D3436" : _c, _d = _a.fontName, fontName = _d === void 0 ? "Roboto Light" : _d, _e = _a.forceLabels, forceLabels = _e === void 0 ? "on" : _e, _f = _a.forceTitles, forceTitles = _f === void 0 ? "on" : _f, _g = _a.format, format = _g === void 0 ? "image/png" : _g, _h = _a.fontSize, fontSize = _h === void 0 ? 13 : _h, fontStyle = _a.fontStyle, _j = _a.groupLayout, groupLayout = _j === void 0 ? "vertical" : _j, height = _a.height, _k = _a.hideEmptyRules, hideEmptyRules = _k === void 0 ? false : _k, labelMargin = _a.labelMargin, language = _a.language, layer = _a.layer, _l = _a.layout, layout = _l === void 0 ? "vertical" : _l, rows = _a.rows, rowWidth = _a.rowWidth, rule = _a.rule, scale = _a.scale, _m = _a.servicePath, servicePath = _m === void 0 ? "wms" : _m, sld = _a.sld, sldBody = _a.sldBody, style = _a.style, width = _a.width, _o = _a.wrap, wrap = _o === void 0 ? false : _o, wrapLimit = _a.wrapLimit;
    var legendOptions = {
        bgColor: bgColor,
        columnHeight: columnHeight,
        countMatched: countMatched,
        dpi: dpi,
        fontAntiAliasing: fontAntiAliasing,
        fontColor: fontColor,
        fontName: fontName,
        fontSize: fontSize,
        fontStyle: fontStyle,
        forceLabels: forceLabels,
        forceTitles: forceTitles,
        groupLayout: groupLayout,
        height: height,
        hideEmptyRules: hideEmptyRules,
        labelMargin: labelMargin,
        layout: layout,
        rows: rows,
        rowWidth: rowWidth,
        width: width,
        wrap: wrap,
        wrap_limit: wrapLimit,
    };
    var requestParams = {
        service: "WMS",
        request: "GetLegendGraphic",
        exceptions: exceptions,
        featureType: featureType,
        format: format,
        language: language,
        layer: layer,
        legend_options: Object.entries(legendOptions)
            .filter(function (_a) {
            var _b = __read(_a, 2), value = _b[1];
            return value !== undefined;
        })
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return "".concat(key, ":").concat(value);
        })
            .join(";"),
        rule: rule,
        scale: scale,
        sld: sld,
        sld_body: sldBody,
        style: style,
    };
    return (0, utils_1.formatUrl)("".concat(base, "/").concat(servicePath), requestParams);
}
exports.createGetLegendGraphicUrl = createGetLegendGraphicUrl;
// to-do: bgcolor, sld, sld_body
function createGetMapUrl(_a) {
    var _b;
    var base = _a.base, bbox = _a.bbox, bboxDigits = _a.bboxDigits, bboxSrs = _a.bboxSrs, capabilities = _a.capabilities, exceptions = _a.exceptions, _c = _a.format, format = _c === void 0 ? "image/png" : _c, _d = _a.height, height = _d === void 0 ? 256 : _d, imageSrs = _a.imageSrs, layerIds = _a.layerIds, _e = _a.srs, srs = _e === void 0 ? "EPSG:4326" : _e, styles = _a.styles, time = _a.time, _f = _a.transparent, transparent = _f === void 0 ? true : _f, _g = _a.version, version = _g === void 0 ? "1.3.0" : _g, _h = _a.width, width = _h === void 0 ? 256 : _h;
    var baseUrl = (function () {
        if (base) {
            return base;
        }
        if (capabilities) {
            return (0, utils_1.findAndParseCapabilityUrl)(capabilities, "GetMap");
        }
        return undefined;
    })();
    if (!baseUrl) {
        throw new Error("failed to create GetMap Url");
    }
    return (0, utils_1.formatUrl)(baseUrl, (_b = {
            bbox: bbox ? (0, utils_1.bboxToString)(bbox, bboxDigits) : undefined,
            bboxsr: bboxSrs ? bboxSrs.toString() : undefined,
            exceptions: exceptions,
            format: format,
            height: height,
            imagesr: imageSrs ? imageSrs.toString() : undefined,
            layers: layerIds.toString(),
            request: "GetMap",
            service: "WMS",
            srs: srs,
            styles: Array.isArray(styles) ? styles.join(",") : styles,
            time: time,
            transparent: transparent,
            version: version
        },
        _b[version === "1.3.0" ? "crs" : "srs"] = srs,
        _b.width = width,
        _b));
}
exports.createGetMapUrl = createGetMapUrl;
